import { useEffect } from 'react';
import DownloadIcon from '../../../../assets/icons/DownloadIcon';
import FileIcon from '../../../../assets/icons/FileIcon';
import {
  Container,
  ContentItem,
  DownloadDiv,
  FileDiv,
  Filename,
  Item,
  ListItem,
  Size,
} from './styles';

import UploadButton from './UploadButton/index';
import { useFileAPI } from '../../../../hooks/useFileAPI';
import Close from '../../../../assets/icons/Close';
import { useSelector } from 'react-redux';
import { getFileLog } from '../../../../state/files/slice';

const FilesSection = ({ active, flow }) => {
  const { handleUpload, handleDelete, status, fetchFiles } = useFileAPI();

  const fileLog = useSelector((state) => state.fileLog);
  const flowFiles = getFileLog(fileLog, flow._id);

  const flowStatus = useSelector((state) => state.activedFlows.pane.flow.status);
  const flowIsFinished = (flowStatus && flowStatus[0] === 'finished')

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchFiles(flow._id);
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return status === 'succeeded' && active ? (
    <Container active={active}>
      {active && (
        <ListItem>
          {flowFiles.files.map((item, i) => (
            <Item key={i}>
              <div style={{ display: 'flex' }}>
                <FileDiv>
                  <FileIcon height="1.1rem" />
                </FileDiv>
                <ContentItem title={item.name}>
                  <Filename>{item.name}</Filename>
                  <Size>Tamanho: {item.readableSize}</Size>
                </ContentItem>
              </div>
              <DownloadDiv>
                <a
                  href={item.url}
                  target="_blank"
                  download={item.name}
                  rel="noreferrer"
                >
                  <DownloadIcon height="0.8825rem" />
                </a>
                <Close
                  style={{ cursor: 'pointer', marginLeft: '0.2rem' }}
                  onClick={() => handleDelete(item._id)}
                  width={'0.75rem'}
                />
              </DownloadDiv>
            </Item>
          ))}
        </ListItem>
      )}
      {!flowIsFinished ? (
      <UploadButton
        onUpload={handleUpload}
        id={flow._id}
        tenantId={flow.tenantId}
        type="flow"
      />)
      :null}
    </Container>
  ) : null;
};

export default FilesSection;
